import Vue from 'vue';
import Component from 'vue-class-component';
import KEYS from '@/values/keys';
import { Status } from '@/models/status.model';
import { COMMONS } from '@/auth/values/auth.values';
import { CORE_ROUTES } from '@/core/core.router';

@Component({
    name: 'validate-code'
})
export default class validateCode extends Vue {
    public invalidCode: boolean = false;
    public timedOut: boolean = false;
    public alreadyValidated: boolean = false;
    public status: Status = new Status();
    public maxAttempts:boolean = false;
    public code: string = null;
    public processing: boolean = false;
    
    get codeInvalid () { 
        return !this.code || this.code?.toString().length < 6;
    }
    
    public goHome(){
        this.$router.push({name: CORE_ROUTES.PUBLIC.HOME.NAME});
    }

    public getCode(code) {
        this.code = this.isValidCode(code);
      }

    isValidCode(code: string): string  {
        const match = code.match(/^\d+$/);
        return match ? match[0] : '';
    }

    public async validateCode(){
        let id = this.$route.params.verificationId;
        this.processing = true;
        try{ 
            let response:any = await this.$Auth.Services.validateCode(Number(id),this.code)
                switch (response.status) {
                    case COMMONS.VALIDATE_MAX_ATTEMPTS:
                        this.maxAttempts = true;
                        setTimeout(() => {
                            this.$router.push({name: CORE_ROUTES.PUBLIC.HOME.NAME});
                        }, 5000);
                        break;
                    case COMMONS.VALIDATE_TIMEOUT:
                        this.timedOut = true;
                        setTimeout(() => {
                            this.$router.push({name: CORE_ROUTES.PUBLIC.HOME.NAME});
                        }, 5000);
                        break;
                    case COMMONS.VALIDATE_INVALID:
                        this.invalidCode = true;
                        break;
                    case COMMONS.VALIDATE_ALREADY_VALIDATED:
                        this.alreadyValidated = true;
                        setTimeout(() => {
                            this.$router.push({name: CORE_ROUTES.PUBLIC.HOME.NAME});
                        }, 5000);
                        break;
                    case COMMONS.VALIDATE_VALID:
                        this.$router.push({ name: CORE_ROUTES.PUBLIC.RESET_PASSWORD.NAME , params: { username: response.userId, verificationId:id } });
                        break;
                    
                    default:
                        break;
                }
                this.processing = false;
        
        } catch(e) {
            this.status.setError();
            this.processing = false;
        }
    }

    beforeMount () {
        const $root: any = this.$root;
        $root.logout(false)
    }
}